import Swiper from 'swiper/bundle';

const Quotes = () => {
    const sliders = document.querySelectorAll('.quotes__swiper');
    if (!sliders.length) return;

    sliders.forEach(slider => {
        if (!(slider instanceof Element)) return;

        const swiperWrapper = slider.querySelector('.quotes__swiper-wrapper');
        if (!swiperWrapper) return;

        // 👇 Equalize the content (not the whole slide)
        const rows = slider.querySelectorAll('.quotes__row');
        let maxHeight = 0;
        rows.forEach(row => {
            const height = row.scrollHeight;
            if (height > maxHeight) maxHeight = height;
        });
        rows.forEach(row => {
            row.style.minHeight = `${maxHeight}px`;
        });

        const parent = slider.closest('.quotes');

        new Swiper(slider, {
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            autoHeight: false,
            spaceBetween: 0,
            loop: false,
            pagination: false,
            navigation: {
                nextEl: parent.querySelector('.quotes__nav--next'),
                prevEl: parent.querySelector('.quotes__nav--prev'),
            },
        });
    });
};

export default Quotes;
